import React from 'react';

const SearchHotkeys = ({ 
  selectedHotkey, 
  onHotkeySelect, 
  disabled = false 
}) => {
  const hotkeys = [
    { id: 'elementary_school', label: '초등학교' },
    { id: 'middle_school', label: '중학교' },
    { id: 'high_school', label: '고등학교' }
  ];

  const handleHotkeyClick = (hotkeyId) => {
    if (disabled) return;
    
    // 같은 버튼을 다시 클릭하면 비활성화하고 재조회
    if (selectedHotkey === hotkeyId) {
      onHotkeySelect(null, true); // 비활성화 시에도 재조회
    } else {
      // 새로운 핫키 선택 시 항상 재조회
      onHotkeySelect(hotkeyId, true);
    }
  };

  return (
    <div className="mt-3">
      <div className="flex gap-2 overflow-x-auto">
        {hotkeys.map((hotkey) => (
          <button
            key={hotkey.id}
            onClick={() => handleHotkeyClick(hotkey.id)}
            disabled={disabled}
            className={`
              flex-1 px-4 py-1.5 text-sm transition-all duration-200
              ${disabled 
                ? 'cursor-not-allowed bg-gray-200 text-gray-400 font-medium' 
                : selectedHotkey === hotkey.id
                  ? 'bg-primary text-white font-bold'
                  : 'bg-gray-100 text-gray-700 font-medium'
              }
            `}
            style={{ borderRadius: '20px' }}
          >
            {hotkey.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SearchHotkeys; 